import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { startDraft } from '../features/draft/draftSlice'

import BuildUpgradeSettings from './BuildUpgradeSettings'
import DraftPhases from '../data/DraftPhases'

function BuildUpgradePanel(props) {
    const buildXPList = useSelector(state => state.draft.buildXPList)
    const draftType = useSelector(state => state.settings.draftType)

    const dispatch = useDispatch()

    function handleStartDraft() {
        dispatch(startDraft(DraftPhases.BuildUpgradePhase))
    }

    const xpTotal = buildXPList.reduce((acc, a) => acc + a.value, 0)

    const xpList = buildXPList.map((item, index) => {
        return <div className="fbsetting" key={index}>
            <label className="fblistleft">{index === 0 ? 'XP:' : ''}</label>
            <span className="fblistcenter">
                <b>{item.value > 0 ? '+' + item.value : item.value}</b> {item.name}
            </span>
            <span className="fblistright"></span>
        </div>
    })
    
    let draftDescription = null

    if (draftType === 'chaos') draftDescription = <div className="description">
            <p style={{marginBottom: '5px'}}>You may use any experience generated by your investigator or the cards drafted to 
            draft upgrades.  Cards will be randomly chosen one by one from all level 1+ cards available to the chosen investigator
            until the available number of experience points have been spent.</p>
            <p>While upgrading, cards will simply be added to a drafted list as usual.  Any cards removed
            because of an upgrade or because they were forcibly removed, such as by On Your Own, will appear in a removed cards list.
            </p>
        </div>
    else if (draftType === 'draft') draftDescription = <div className="description">
            <p>You may use any experience generated by your investigator or the cards drafted to draft upgrades.  Select
            cards one by one from a random display of level 1+ cards available to the chosen investigator.  Each card
            will be selected from a number of cards determined by the "Cards to select from" option.</p>
            <p>While upgrading, cards will simply be added to a drafted list as usual.  Any cards removed
            because of an upgrade or because they were forcibly removed, such as by On Your Own, will appear in a removed cards list.</p>
        </div>
/*They will not be removed from the original list, to keep the record of drafts intact.*/
/*            <p>If an upgrade or cost modifier, such as Arcane Research or the selected taboo list, is in effect, the modified experience
            cost will be displayed in the upper right corner of the card.  Hovering over this box will display details and allow you
            to change settings such as whether to upgrade or not.  Clicking the box will keep this box open, even when you are not
            hovering, and clicking again will close it.</p>
*/
    const button = <button className="button-rect button-green" onClick={handleStartDraft}>Draft</button>

    return (
        <div className='settingsDiv'>
            <h3>Bonus Experience</h3>
            <h2 className="draft-quantity">{xpTotal} XP</h2>
            <BuildUpgradeSettings />
            {xpList}
            {draftDescription}
            {button}
        </div>
    )
}

export default BuildUpgradePanel